import classNames from 'classnames'
import { Dropdown as DropdownBase } from 'react-bootstrap'
import styles from './Dropdown.module.scss'

export const CustomDropdown = (
  props: React.ComponentProps<typeof DropdownBase>
) => (
  <DropdownBase
    {...props}
    className={classNames(styles.dropdownManage, props.className)}
  />
)

CustomDropdown.Toggle = DropdownBase.Toggle
CustomDropdown.Menu = DropdownBase.Menu
CustomDropdown.Item = DropdownBase.Item
CustomDropdown.ItemText = DropdownBase.ItemText
CustomDropdown.Divider = DropdownBase.Divider
CustomDropdown.Header = DropdownBase.Header

export default CustomDropdown
